import React from 'react';
import PropTypes from 'prop-types';
import HamburgerMenuIcon from 'dibs-vg/dist/react/hamburger-menu';
import GridIcon from 'dibs-vg/dist/react/grid';
import classNames from 'classnames';

import { viewModes } from '../../constants';

// Tracking
import { trackEvent } from 'dibs-tracking';

import styles from './styles/ToggleViewButtons.scss';

function trackToggleViewMode(viewMode = '') {
    viewMode = viewMode.toLowerCase();
    trackEvent({
        action: 'toggle results view',
        label: viewMode,
        category: 'favorites',
        additional: { viewMode },
    });
}

function ToggleViewButtons({ onClick, viewMode }) {
    const isGridView = viewMode === viewModes.GRID;
    const isListView = viewMode === viewModes.LIST;
    return (
        <div className={styles.container}>
            <button
                className={classNames(styles.viewToggle, {
                    [styles.isSelected]: isGridView,
                })}
                onClick={() => {
                    if (!isGridView) {
                        onClick(viewModes.GRID);
                        trackToggleViewMode(viewModes.GRID);
                    }
                }}
            >
                <GridIcon className={styles.svgIcon} />
            </button>
            <button
                className={classNames(styles.viewToggle, {
                    [styles.isSelected]: isListView,
                })}
                onClick={() => {
                    if (!isListView) {
                        onClick(viewModes.LIST);
                        trackToggleViewMode(viewModes.LIST);
                    }
                }}
            >
                <HamburgerMenuIcon className={styles.svgIcon} />
            </button>
        </div>
    );
}

ToggleViewButtons.propTypes = {
    viewMode: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
};

export default ToggleViewButtons;
